export type RoleLevelInfo = {
  id: number;
  name: string;
};

export type RoleLevelsRecord = Record<number, RoleLevelInfo>;

export enum RoleLevel {
  ORGANIZATION_USER = 100,
  ORGANIZATION_ADMIN = 1000,
  PLANET_USER = 1999,
  PLANET_ADMIN = 2000,
}
